<template>
  <div v-if="asyncDataStatus_isReady">
    <solution-sheet v-if="calculation" :calculation="calculation" />
    <p v-else>Cálculo não encontrado</p>
  </div>
</template>

<script>
import { asyncDataStatus } from "@/mixins";
import { mapActions, mapState } from "vuex";
import LayoutMain from "@/layouts/l-main";
import { SolutionSheet } from "@/components";

export default {
  mixins: [asyncDataStatus],

  props: {
    id: {
      required: true,
    },
  },

  components: {
    LayoutMain,
    SolutionSheet,
  },

  computed: {
    ...mapState(["usersCalculations"]),

    calculation() {
      return this.usersCalculations.find(({ id }) => id === this.id);
    },
  },

  methods: {
    ...mapActions(["fetchUsersCalculation"]),
  },

  created() {
    this.fetchUsersCalculation(this.id)
      .then(() => {
        console.log("this.calculation:", this.calculation);
        this.asyncDataStatus_done();
      })
      .catch(() => {
        this.asyncDataStatus_done();
      });
  },
};
</script>
